import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { ColorPickerFormControl } from "../Web/ColorPickerFormControl";
import { XColumnContainer, XColumnContainerColumn } from "../../Containers";
import { LabelFormControl } from "../Web/LabelFormControl";
import { TextControlSize, TextControlStyle } from "../../Utilities/FormDesignConstants";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

function getUI(): { form: FormConfiguration } {
    let ui = new FormConfiguration();
    let container = new XColumnContainer();
    let col1 = new XColumnContainerColumn();
    let col2 = new XColumnContainerColumn();
    col2.interControlSpacing = 20;

    container.add(col1);
    container.add(col2);
    ui.add(container);

    let label = new LabelFormControl();
    label.text = "Large Size";
    col1.add(label);

    let textField = new ColorPickerFormControl();
    textField.label = "Text Field Label";
    textField.valueName = "value";
    textField.requiredOnAllOutcomes = false;
    col1.add(textField);

    textField = new ColorPickerFormControl();
    textField.label = "Text Field Label";
    textField.style = TextControlStyle.OUTLINE;
    textField.valueName = "value";
    textField.requiredOnAllOutcomes = false;
    textField.overrideStyle = true;
    col1.add(textField);

    textField = new ColorPickerFormControl();
    textField.label = "Text Field Label";
    textField.style = TextControlStyle.SHADED;
    textField.valueName = "value";
    textField.requiredOnAllOutcomes = false;
    textField.overrideStyle = true;
    col1.add(textField);

    textField = new ColorPickerFormControl();
    textField.label = "Text Field Label";
    textField.valueName = "value";
    textField.style = TextControlStyle.UNDERLINED;
    textField.requiredOnAllOutcomes = false;
    textField.overrideStyle = true;
    col1.add(textField);

    label = new LabelFormControl();
    label.text = "Small Size";
    col2.add(label);

    textField = new ColorPickerFormControl();
    textField.label = "Text Field Label";
    textField.valueName = "value";
    textField.requiredOnAllOutcomes = false;
    textField.size = TextControlSize.SMALL;
    col2.add(textField);

    textField = new ColorPickerFormControl();
    textField.label = "Text Field Label";
    textField.style = TextControlStyle.OUTLINE;
    textField.valueName = "value";
    textField.size = TextControlSize.SMALL;
    textField.requiredOnAllOutcomes = false;
    textField.overrideStyle = true;
    col2.add(textField);

    textField = new ColorPickerFormControl();
    textField.label = "Text Field Label";
    textField.style = TextControlStyle.SHADED;
    textField.valueName = "value";
    textField.size = TextControlSize.SMALL;
    textField.requiredOnAllOutcomes = false;
    textField.overrideStyle = true;
    col2.add(textField);

    textField = new ColorPickerFormControl();
    textField.label = "Text Field Label";
    textField.style = TextControlStyle.UNDERLINED;
    textField.valueName = "value";
    textField.size = TextControlSize.SMALL;
    textField.requiredOnAllOutcomes = false;
    textField.overrideStyle = true;
    col2.add(textField);

    return { form: ui };
}

export const ColorPickerStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Color Picker",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            const data = new ExecutionData();
            data.values["value"] = UIStyleConstants.BLUE_COLOR;

            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Color Picker",
        "With Value",
    ),
];
